// ==============================|| OVERRIDES - INPUT BASE (mobile zoom fix) ||============================== //

/**
 * iOS Safari auto-zooms focused inputs when computed font-size < 16px and often
 * leaves the page partially zoomed after blur. Force 16px on mobile for all inputs.
 */
export default function InputBase(theme) {
  const mobileInputFontSize = {
    [theme.breakpoints.down('md')]: {
      fontSize: '16px'
    }
  };

  return {
    MuiInputBase: {
      styleOverrides: {
        input: mobileInputFontSize,
        inputSizeSmall: mobileInputFontSize
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: mobileInputFontSize,
        inputSizeSmall: mobileInputFontSize
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        input: mobileInputFontSize,
        inputSizeSmall: mobileInputFontSize
      }
    },
    MuiInput: {
      styleOverrides: {
        input: mobileInputFontSize,
        inputSizeSmall: mobileInputFontSize
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: mobileInputFontSize,
        outlined: mobileInputFontSize
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        input: mobileInputFontSize,
        inputRoot: {
          [theme.breakpoints.down('md')]: {
            '& .MuiInputBase-input': {
              fontSize: '16px'
            }
          }
        }
      }
    }
  };
}
